<template>
    <div class='view view--home'>
        <div data-scroll-section>
            <SuperheroTier id='hero' data-scroll-id='hero' data-scroll />
        </div>
        <div data-scroll-section>
            <PackagesTier id='packages' data-scroll-id='packages' data-scroll />
        </div>
        <div data-scroll-section>
            <CollectionCarouselTier
                v-for='collection in homeCollections'
                :id='`${collection.slug}-collection`'
                :slug='collection.slug'
                :data-scroll-id='`${collection.slug}-collection`'
                :is-show-heading='true'
                :is-link-title='collection.is_link_title || false'
                :is-show-view-link='collection.is_show_view_link || false'
                data-scroll
            />
        </div>
        <div v-if='isShowHomeWatchSection' data-scroll-section>
            <AboutTier id='about' data-scroll-id='about' data-scroll />
        </div>
        <div data-scroll-section>
            <FaqTier id='faqs' data-scroll-id='faqs' data-scroll />
        </div>

        <div data-scroll-section>
            <Footer :isShowPrefooter='true' id='footer' data-scroll-id='footer' data-scroll />
        </div>
    </div>
</template>


<script>
import SuperheroTier from '^/components/tiers/SuperheroTier.vue'
import CollectionCarouselTier from '^/components/tiers/CollectionCarouselTier.vue'
import PackagesTier from '^/components/tiers/PackagesTier.vue'
import AboutTier from '^/components/tiers/AboutTier.vue'
import FaqTier from '^/components/tiers/FaqTier.vue'
import Footer from '^/components/Footer.vue'

export default {
    name: 'HomeView',
    data: () => ({
        isShowHomeWatchSection: window.app?.isShowHomeWatchSection || false
    }),
    computed: {
        homeCollections() {
            return window.app?.homeCollections || []
        }
    },
    components: {
        SuperheroTier,
        CollectionCarouselTier,
        PackagesTier,
        AboutTier,
        FaqTier,
        Footer
    }
}
</script>